/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import SkeletonText from '../SkeletonText/SkeletonText.js';
import { usePrefix } from '../../internal/usePrefix.js';

var _SkeletonText, _SkeletonText2, _SkeletonText3, _SkeletonText4;
function PaginationSkeleton(_ref) {
  let {
    className,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: cx(`${prefix}--pagination`, `${prefix}--skeleton`, className)
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--pagination__left`
  }, _SkeletonText || (_SkeletonText = /*#__PURE__*/React__default.createElement(SkeletonText, {
    width: "70px"
  })), _SkeletonText2 || (_SkeletonText2 = /*#__PURE__*/React__default.createElement(SkeletonText, {
    width: "35px"
  })), _SkeletonText3 || (_SkeletonText3 = /*#__PURE__*/React__default.createElement(SkeletonText, {
    width: "105px"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--pagination__right ${prefix}--pagination--inline`
  }, _SkeletonText4 || (_SkeletonText4 = /*#__PURE__*/React__default.createElement(SkeletonText, {
    width: "70px"
  }))));
}
PaginationSkeleton.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string
};

export { PaginationSkeleton, PaginationSkeleton as default };
